export default __webpack_public_path__ + "static/media/logo.18fe7aab.svg";